import React from 'react';
import { toast } from 'react-toastify';

import irelandApi from '../irelandApi';
import ToastMessage from '../components/common/toast-message';

export const getStockNotifications = () => dispatch => {
  dispatch({ type: 'GET_STOCK_NOTIFICATIONS_PENDING' });

  return irelandApi
    .get('/api/products/stock_notifications')
    .then(({ data: payload }) => {
      dispatch({ type: 'GET_STOCK_NOTIFICATIONS_FULFILLED', payload });
    }).catch(error => {
      dispatch({ type: 'GET_STOCK_NOTIFICATIONS_REJECTED', payload: error });
    })
}

export const addStockNotification = productId => dispatch => {
  const payload = { productId };

  dispatch({ type: 'ADD_STOCK_NOTIFICATION', payload });

  return irelandApi
    .post(`/api/products/${productId}/stock_notification`)
    .then(() => {
      dispatch({ type: 'STOCK_NOTIFICATION_ADDED' });

      toast.success(<ToastMessage iconStyle="success" message="Notification set"/>);
    }).catch(() => {
      dispatch({ type: 'ROLLBACK_ADD_STOCK_NOTIFICATION', payload });

      toast.error(<ToastMessage iconStyle="error" message="Failed to add notification"/>);
    });
}

export const removeStockNotification = productId => dispatch => {
  const payload = { productId };

  dispatch({ type: 'REMOVE_STOCK_NOTIFICATION', payload });

  return irelandApi
    .delete(`/api/products/${productId}/stock_notification`)
    .then(() => {
      dispatch({ type: 'STOCK_NOTIFICATION_REMOVED' });

      toast.success(<ToastMessage iconStyle="success" message="Notification deleted"/>);
    }).catch(() => {
      dispatch({ type: 'ROLLBACK_REMOVE_STOCK_NOTIFICATION', payload });

      toast.error(<ToastMessage iconStyle="error" message="Failed to delete notification"/>);
    });
}



// WEBPACK FOOTER //
// ./src/actions/stock-notifications.js